import React from 'react';
import { useGlobal, getGlobal } from 'reactn';
import { formatLongDate, formatCurrencyNum } from '../../../helpers';
import Card from '../../common/card/Card';
import Button from '../../common/button/Button';
import Speedpay from '../../common/Speedpay';
import autoPay from '../../assets/auto-pay.png';

const UpcomingPayment = ({ ...rest }) => {
  const { siteDetails } = getGlobal();
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );

  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];

  if (selectedServiceAccount === undefined) {
    return <h4>SERVICE ACCOUNT UNAVAILABLE</h4>;
  }

  const { AUTO_PAY } = selectedServiceAccount.data;
  const { latestBillUrl } = selectedServiceAccount.summaryData.data;

  return (
    <Card
      title="Upcoming Payment"
      titleExternal="View Current Bill >"
      titleExternalLinkTo={latestBillUrl}
      titleExternalClassname="text-xs ml-2 text-right text-white normal-case"
      backgroundClass="bg-blue-dark flex flex-col"
      {...rest}
    >
      <div>
        <h4 className="mb-4 text-white font-medium">Payment Due</h4>
        <p className="text-4xl text-white mb-8">
          {selectedServiceAccount.data.DUE_DATE ? formatLongDate(
            selectedServiceAccount.data.DUE_DATE,
            selectedServiceAccount
          ) : 'Bill Not Due'}
        </p>
        <h4 className="mb-4 text-white font-medium">Amount Due</h4>
        <p className="text-4xl text-white mb-10">
          {formatCurrencyNum(
            selectedServiceAccount.summaryData.data.accountBalance
          )}
        </p>
      </div>
      <div className="h-full flex flex-col justify-end">
        <Speedpay customerAccount={selectedServiceAccount.data} />
        {!AUTO_PAY && (
          <Button
            iconUrl={autoPay}
            href={siteDetails.mcwa_automatic_bill_pay_url}
            target="_blank"
            rel="noopener noreferrer"
            // secondary
            className="w-full"
          >
            Setup Automatic Bill Pay (No Fee)
          </Button>
        )}
      </div>
    </Card>
  );
};

export default UpcomingPayment;
